import {Node, NodeSpec} from 'prosemirror-model';

export const youtube_embed_spec: NodeSpec = {
  attrs: {
    src: {default: null},
    videoId: {default: null},
    startTime: {default: null},
  },
  group: 'block',
  draggable: true,
  parseDOM: [
    {
      tag: 'iframe.youtube-embed',
      getAttrs(dom) {
        const src = dom.getAttribute('src');
        // Extract video ID from YouTube URL if needed
        let videoId = null;
        if (src) {
          const match = src.match(/(?:youtube\.com\/embed\/|youtu\.be\/)([a-zA-Z0-9_-]+)/);
          if (match) videoId = match[1];
        }
        return {
          src,
          videoId,
        };
      },
    },
  ],
  toDOM(node: Node) {
    let youtubeUrl = node.attrs.videoId
      ? `https://www.youtube.com/embed/${node.attrs.videoId}`
      : node.attrs.src;

    if (node.attrs.startTime) {
      youtubeUrl += (youtubeUrl.includes('?') ? '&' : '?') + `start=${node.attrs.startTime}`;
    }

    return [
      'div',
      {
        class: 'gdoc-embed-wrapper',
      },
      [
        'iframe',
        {
          class: 'youtube-embed',
          src: youtubeUrl,
          width: '100%',
          height: '480px',
          frameborder: '0',
          allowfullscreen: 'true',
          allow:
            'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture',
        },
      ],
    ];
  },
};
